import { render, staticRenderFns } from "./DealPaymentSelector.vue?vue&type=template&id=4972bd84&"
import script from "./DealPaymentSelector.vue?vue&type=script&lang=js&"
export * from "./DealPaymentSelector.vue?vue&type=script&lang=js&"
import style0 from "./DealPaymentSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports